import { useSelectedReportId } from 'modules/campaigns/modules/campaigns-reports/hooks/useSelectedReportId';
import { FEATURE_FLAGS, useConfigMatch } from 'modules/taboola-common-frontend-modules/account-configurations';
import { CREATIVE_REPORT_ID } from '../modules/campaigns/modules/campaigns-reports/config/reports/creative/creativeReportId';

export const useIsIncludeSubmissionData = () => {
    const [selectedReport] = useSelectedReportId();
    const isIncludeSubmissionDataInAdsReport = useConfigMatch({
        [FEATURE_FLAGS.SUBMISSION_DATA_ALLOWED_IN_ADS_REPORT]: 'true',
    });

    return selectedReport === CREATIVE_REPORT_ID && isIncludeSubmissionDataInAdsReport;
};
